export const NOTIFICATION_TAGS = {
    NOTIFICATIONS: "GetNotifications",
} as const;